import { MenuItem, Select } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { AppearanceCellProps, GenericTableColumnAppearance } from './dto';
import { decodeColumnAppearanceState, encodeColumnAppearanceState } from './utils';

export const AppearanceCell = ({ column, onChange }: AppearanceCellProps) => {
    return (
        <Select<GenericTableColumnAppearance>
            fullWidth
            value={decodeColumnAppearanceState(column)}
            onChange={(event) => {
                const newAppearance = event.target.value as GenericTableColumnAppearance;

                onChange({ ...column, ...encodeColumnAppearanceState(newAppearance) });
            }}
        >
            <MenuItem value={GenericTableColumnAppearance.ShowColumn}>
                <FormattedMessage id="inside-fifa.generic-tables.column-appearance.show-column" />
            </MenuItem>
            <MenuItem value={GenericTableColumnAppearance.Hide}>
                <FormattedMessage id="inside-fifa.generic-tables.column-appearance.hide" />
            </MenuItem>
            <MenuItem value={GenericTableColumnAppearance.Responsive}>
                <FormattedMessage id="inside-fifa.generic-tables.column-appearance.responsive" />
            </MenuItem>
            <MenuItem value={GenericTableColumnAppearance.ShowInExpandedRow}>
                <FormattedMessage id="inside-fifa.generic-tables.column-appearance.show-in-expanded-row" />
            </MenuItem>
            <MenuItem value={GenericTableColumnAppearance.ShowFullWidthRow}>
                <FormattedMessage id="inside-fifa.generic-tables.column-appearance.show-as-full-width-row" />
            </MenuItem>
        </Select>
    );
};
